module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer006"
    }
  }, [_c('p', {
    staticClass: "TOC_Contents"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pagexi",
      "title": "xi"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "TOC_1exer",
    attrs: {
      "id": "_idParaDest-4"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor001"
    }
  }), _vm._v("Exercises")]), _vm._v(" "), _c('p', {
    staticClass: "TOC_chpt"
  }, [_c('a', {
    attrs: {
      "href": "#/WFI#_idTextAnchor004"
    }
  }, [_vm._v("Understanding the Breath")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_chpt"
  }, [_c('a', {
    attrs: {
      "href": "#/WFI1#_idTextAnchor009"
    }
  }, [_vm._v("Spatial Awareness")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_chpt"
  }, [_c('a', {
    attrs: {
      "href": "#/WFI2#_idTextAnchor012"
    }
  }, [_vm._v("Reaching the Divine")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_chpt"
  }, [_c('a', {
    attrs: {
      "href": "#/WFI3#_idTextAnchor016"
    }
  }, [_vm._v("The World Tree Within")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_chpt"
  }, [_c('a', {
    attrs: {
      "href": "#/WFI4#_idTextAnchor019"
    }
  }, [_vm._v("Calming the Sea and Sky")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_chpt"
  }, [_c('a', {
    attrs: {
      "href": "#/WFI5#_idTextAnchor026"
    }
  }, [_vm._v("Breathing the Runes")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_chpt"
  }, [_c('a', {
    attrs: {
      "href": "#/WFI6#_idTextAnchor029"
    }
  }, [_vm._v("Going to the Wells")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_chpt"
  }, [_c('a', {
    attrs: {
      "href": "#/WFI7#_idTextAnchor034"
    }
  }, [_vm._v("Community Expectations")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_chpt _idGenParaOverride-1"
  }, [_c('a', {
    attrs: {
      "href": "#/WFI8#_idTextAnchor037"
    }
  }, [_vm._v("Engaging with Sources")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-022cc29c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Exer.vue
// module id = 69
// module chunks = 0